/**
 * Devuelve `destino` si es una ruta interna segura, o `'/'` en cualquier otro caso.
 * Sustitución silenciosa, sin lanzar error: pensada para el destino de retorno tras
 * login/registro/confirmación (`?redirect=`), donde un valor manipulado por el cliente
 * nunca debe poder sacar al usuario de la aplicación (open redirect).
 *
 * Rechaza: `undefined`/cadena vacía, cualquier URL absoluta (con esquema, p. ej.
 * `https://…`), las que empiezan por `//` (protocolo relativo, también salen del origen),
 * las que contienen `\` (los navegadores la normalizan a `/`, así que `/\evil.com` es un
 * esquema disfrazado) y todo lo que no empiece por `/`.
 */
export const safeRedirect = (destino: string | undefined): string => {
	if (!destino) {
		return '/';
	}
	// Cualquier URL absoluta (con esquema, `https://…`) y cualquier protocolo relativo
	// (`//evil.com`) no empiezan por una única `/`, así que esta única comprobación de
	// prefijo ya las descarta a ambas.
	if (!destino.startsWith('/') || destino.startsWith('//')) {
		return '/';
	}
	if (destino.includes('\\')) {
		return '/';
	}
	return destino;
};
